import { takeLatest, call } from 'redux-saga/effects'
import * as fromActions from '../../actions/lessons-admin.action'
import { editLessonsOrder } from '../../../api/administration/lessons/Edit'
import { ILessonModel } from '../../../models/lesson.model'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleEditLessonsOrder(lessons: ILessonModel[]) {
  return await editLessonsOrder(lessons)
}

function* editLessonsOrderEffectSaga(action: any) {
  try {
    yield call(handleEditLessonsOrder, action.payload)
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editLessonOrderWatcherSaga() {
  yield takeLatest(fromActions.LESSONS_ORDER_EDIT, editLessonsOrderEffectSaga)
}
